var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6562 11.25C10.6562 17.9687 10.6562 17.8437 10.6562 17.9062H20H29.3437C29.3437 17.8437 29.3437 17.9687 29.3437 11.25C29.3437 0.75 10.6562 0.75 10.6562 11.25Z",
    fill: "url(#paint0_linear_536_2951)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3125 30.4375C30.2187 28.7188 28.3125 27.5938 26.125 27.5938H23.6562V25H16.3125V27.5938H13.8437L10.9062 33.3437L28.25 34.4688L31.3125 30.4375Z",
    fill: "url(#paint1_linear_536_2951)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8437 27.5938C10.4375 27.5938 7.6875 30.3437 7.6875 33.75C7.6875 35.0937 7.96875 35.75 10.1562 36.2187C10.1562 36.2187 17.5 37.5 20 37.5C22.5 37.5 29.8438 36.2187 29.8438 36.2187C32.0313 35.75 32.3125 35.125 32.3125 33.75C32.3125 32.5312 31.9688 31.4062 31.3438 30.4375C18.75 35.4375 13.5312 30.7188 13.8437 27.5938Z",
    fill: "url(#paint2_linear_536_2951)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 27.25C26.7501 27.25 28.2501 21.8437 28.5626 19.2812C31.9376 19.1562 31.8751 14.0937 28.5626 14.0937C25.1251 11 25.0001 10.625 21.3438 11.2188C20.8126 11.3125 19.8438 11.4063 18.6563 11.2188C15.0001 10.625 14.8751 11 11.4376 14.0937C8.12505 14.0937 8.06255 19.1562 11.4376 19.2812C11.7501 21.8125 13.2501 27.25 20.0001 27.25Z",
    fill: "url(#paint3_radial_536_2951)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1562 16.9062C16.8121 16.9062 17.3437 16.3746 17.3437 15.7187C17.3437 15.0629 16.8121 14.5312 16.1562 14.5312C15.5004 14.5312 14.9688 15.0629 14.9688 15.7187C14.9688 16.3746 15.5004 16.9062 16.1562 16.9062Z",
    fill: "url(#paint4_linear_536_2951)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8438 16.9062C24.4996 16.9062 25.0312 16.3746 25.0312 15.7187C25.0312 15.0629 24.4996 14.5312 23.8438 14.5312C23.1879 14.5312 22.6562 15.0629 22.6562 15.7187C22.6562 16.3746 23.1879 16.9062 23.8438 16.9062Z",
    fill: "url(#paint5_linear_536_2951)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_536_2951",
    x1: 10.6557,
    y1: 10.6313,
    x2: 29.3443,
    y2: 10.6313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292B2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_536_2951",
    x1: 21.1145,
    y1: 34.4898,
    x2: 21.1145,
    y2: 25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48574"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2594,
    stopColor: "#D18372"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4393,
    stopColor: "#C87B6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5951,
    stopColor: "#B96D5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7363,
    stopColor: "#A35B4D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8259,
    stopColor: "#914B3E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_536_2951",
    x1: 20,
    y1: 37.5,
    x2: 20,
    y2: 27.6071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC6A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F98DA4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_536_2951",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.0011 10.5856) scale(22.3493 22.3492)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D48574"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4755,
    stopColor: "#D28372"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6663,
    stopColor: "#CB7C6C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8059,
    stopColor: "#BF7161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#AE6152"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C5043"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_536_2951",
    x1: 14.5481,
    y1: 14.3139,
    x2: 16.6509,
    y2: 16.1203,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353738"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_536_2951",
    x1: 22.2875,
    y1: 14.2408,
    x2: 24.3244,
    y2: 16.1807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505354"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353738"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.dfce7550eab68f48bec880ae0f92f3a4.svg";
export { ForwardRef as ReactComponent };